<template>
  <q-td :props="props" :key="colKey">
    <ams-base-cell-anmerkungen
      :props="props"
      :model="model"
      :api="api"
      :hasWritePermission="hasWritePermission"
      @updateData="$emit('updateData', $event)"
    />
  </q-td>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import BaseCellAnmerkungen from "../../../components/BaseCells/BaseCellAnmerkungen.vue";
import { useGefahrstoff } from "../../../services/gefahrstoff.service";
import { gefahrstoffeModel } from "../../../data";

export default defineComponent({
  components: {
    "ams-base-cell-anmerkungen": BaseCellAnmerkungen,
  },
  props: {
    props: {
      type: Object,
      required: true,
    },
    colKey: {
      type: String,
      required: true,
    },
    hasWritePermission: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    return {
      model: gefahrstoffeModel,
      api: useGefahrstoff(),
    };
  },
});
</script>
